import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashesProps = {
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashes: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashesProps
> = props => {
  let version = props.version || {},
    bytecodeHash = version.bytecodeHash;
  return (
    <div className="grid pt-">
      <div className="grid__item col-1-1 pt-">
        <div className="grid bo--1 border-color--muted font--12 p-">
          Bytecode hashes are calculated from the Java bytecode and are more reliable than file
          hashes, which are prone to false positives and negatives.
        </div>
      </div>
      <div className="grid__item col-1-1 pt">
        <div className="grid grid--middle flex">
          <div className="grid__item col-1-3 font--h7 phone--col-1-1 phone--pl0">
            Bytecode hash:
          </div>
          <div className="grid__item col-2-3 phone--col-1-1 phone--pl0">
            <div className="font-family--code bg-color--black-dark color--white col-1-1 ph-- pv- text--overflow phone--no-overflow">
              {bytecodeHash}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionDetailsBytecodeHashes;
